import { ListItemIcon, ListItemText } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { JSX, useState } from "react";

import { Menu, MenuItem } from "@mui/material";
import getRouteAction from "../../Helpers/dataUitAttributes/dataUitAttributes";
import { useNavigate } from "react-router";

export interface BNFabNavigationLink {
  title: string;
  url?: string;
  onClick?: () => void;
  icon?: any;
  color?: string;
  hiddenOnMobile?: boolean;
  hiddenOnDesktop?: boolean;
  dataUit?: string;
}

interface BNFabProps {
  actions: Array<BNFabNavigationLink>;
  directionDown?: boolean;
  isSpa: (path: string) => boolean;
  onNavigate?: (a?: any) => any;
  OpenMenuComponent: JSX.Element;
  color?: string;
}
const BNFab: React.FC<BNFabProps> = (props) => {
  const { OpenMenuComponent, actions, onNavigate, isSpa, color } = props;
  const navigate = useNavigate();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null as HTMLElement | null);
  const [fabId] = useState("fab" + Math.floor(Math.random() * 10000));

  const menuId = `${fabId}-button-links`;
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const ResolveIcon = (link: BNFabNavigationLink) => {
    if (link.icon) {
      return (
        <ListItemIcon sx={{ color }}>
          <link.icon />
        </ListItemIcon>
      );
    }
    return null;
  };
  const nonEmptyActions = actions.filter((action) => !!action);
  const fabReady = nonEmptyActions.length > 0;
  return (
    <>
      <div
        aria-owns={anchorEl ? menuId : undefined}
        aria-haspopup="true"
        onClick={actions.length ? handleOpen : () => {}}
        tabIndex={-1}
        data-uit-container={fabReady ? "open-fab-container" : undefined}
      >
        {OpenMenuComponent}
      </div>
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        data-uit-container={fabReady ? "fab-item-list" : undefined}
        slotProps={{
          list: {
            sx: { paddingTop: 1.5, paddingBottom: 1.5 },
          },
          paper: {
            sx: { borderRadius: 2 },
          },
        }}
      >
        {nonEmptyActions.map((link, index) => (
          <MenuItem
            key={`${fabId}-menu-item-${index}`}
            sx={{
              justifyContent: "center",
              paddingTop: 1,
              paddingBottom: 1,
              paddingLeft: 3,
              paddingRight: 3,
              color: link?.color,
              [theme.breakpoints.up("md")]: {
                display: link.hiddenOnDesktop ? "none" : undefined,
              },
            }}
            disableGutters={true}
            onClick={() => {
              onNavigate?.(link.title);
              if (link.url !== undefined) {
                if (isSpa(link.url)) {
                  void navigate(link.url);
                } else {
                  window.location.assign(link.url);
                }
              }
              link.onClick?.();
              handleClose();
            }}
            data-uit={link.dataUit ? link.dataUit : getRouteAction(link?.url || link.title)}
          >
            <ListItemText sx={{ marginRight: "3rem" }}>{link.title}</ListItemText>
            {ResolveIcon(link)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
export default BNFab;
